export default {"src":"/_next/static/media/haxe.32ac7bcf.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};